// function from the BPM menu
import {BpmActions, BpmBoolProps, BpmEname, BpmStatProps, BpmStatus, GWTStatusData} from './types';
import {AlertOverviewType} from '../../../../features/Automations/modules/BPMRules/api/types';
import {bpmRulesStorage} from '../../../../features/Automations/modules/BPMRules/BPM.rules.storage';

export function onBpmAction(methodName: BpmActions | null) {
    if (!methodName) return;
    return window['bpmMain']?.onBpmAction?.(methodName);
}

export function getJavaScriptObjectGenMsgs() {
    return window['bpmMain']?.getJavaScriptObjectGenMsgs?.() || {};
}

// get the statuses that can be inserted
export function getInactiveStatusesTitles() {
    const data = window['bpmMain']?.getInactiveStatusesTitles?.();
    const dataKeys = Object.keys(data || {});

    return data[dataKeys[0]] || [];
}

export function getConnection() {
    return (
        window['bpmMain'] && window['bpmMain'].getConnection && window['bpmMain'].getConnection()
    );
}

export function getCurSession() {
    return window['bpmMain']?.getCurSession?.();
}

export function getBpmDataByKey(key: string) {
    return window['bpmMain']?.getBpmDataByKey?.(key);
}

export function getStatusRules(toStatus: string, fromStatus: string): Array<AlertOverviewType> {
    const storage = bpmRulesStorage.getStorage(getCurSession());

    const fromStatusId = getStatusID(fromStatus)?.toString();
    const toStatusId = getStatusID(toStatus)?.toString();
    const storageData = storage?.getRules(fromStatusId, toStatusId);

    if (storageData) {
        return storageData;
    }

    if (toStatus && fromStatus) {
        const status: GWTStatusData = getBpmDataByKey('Statuses')?.[0].Status.find(
            (status: GWTStatusData) => status.title === fromStatus
        );

        /*
         * In case when the user added a new path we should return an empty array fallback,
         * because we don't have the updated data from GWT dataset (EP-35058)
         * */

        const res =
            status.Links?.[0].Link.find(link => {
                return link.toid === toStatusId;
            })?.Rules?.[0].Rule || [];

        storage.setRules(fromStatusId, toStatusId, res);

        return res;
    }

    const status = getBpmDataByKey('Statuses')?.[0].Status.find(
        (status: GWTStatusData) => status.title === toStatus
    );

    const res = status?.Rules?.[0].Rule;

    storage.setRules(fromStatusId, toStatusId, res);

    return res || [];
}

export const getBpmStatusesAsChooseList = (statusName: string) => {
    if (!statusName) return [];

    const statuses = getToStatuses(statusName);

    return (
        statuses.map(item => {
            return {
                label: item.title,
                value: Number(item.id),
                data: {
                    color: item.color
                }
            };
        }) || []
    );
};

export function getBPMAlertChooses() {
    return getBpmDataByKey('AlertChooses')?.[0];
}

// get the boolean properties of the status
export function getStatusProperties(statusName: string | null) {
    const data = window['bpmMain']?.getStatusProperties?.(statusName || null);
    const dataKeys = Object.keys(data || {});

    return data[dataKeys[0]] || [];
}

export function createBpmPropertiesDs(
    status: BpmStatus,
    eName: BpmEname | null,
    boolProps: Array<BpmBoolProps>,
    statProps: Array<BpmStatProps>
) {
    return window['bpmMain']?.createBpmPropertiesDs?.(status, eName, boolProps, statProps);
}

// get the 'transfer to status' properties of a status
export function getStatusStatProperties(statusName: string | null) {
    //We need send Null because when we send empty string we will have error
    const data = window['bpmMain']?.getStatusStatProperties?.(statusName || null);
    const dataKeys = Object.keys(data || {});

    return data[dataKeys[0]] || [];
}

export function getStatusEname(statusName: string) {
    return window['bpmMain']?.getStatusEname?.(statusName)?.value || '';
}

export function getStatusPos(statusName: string): number {
    return window['bpmMain']?.getStatusEname?.(statusName)?.pos;
}

export function getStatusID(statusName: string): number {
    return window['bpmMain']?.getStatusID?.(statusName) || 0;
}

export function getStatusDetails(statusName: string) {
    return window['bpmMain']?.getStatusDetails?.(statusName);
}

export function setNewlyInsertedStatusFromReact(statusName: string) {
    return window['bpmMain']?.setNewlyInsertedStatusFromReact?.(statusName);
}

export function setIsNewStatusFromReact(isNewStatus: boolean) {
    return window['bpmMain']?.setIsNewStatusFromReact?.(isNewStatus);
}

export function toggleBpmFlow(value: boolean) {
    return window['bpmMain']?.toggleBpmFlow?.(value);
}

export function getIsDisablePath() {
    return window['bpmMain']?.getIsDisablePath?.();
}

export function openRulesReport(fromId: number, toId: number) {
    /**
    id1: number -
        In BPM status - 0.
        In BPM path - The Id of the BPM Status from which the path starts.
    id2: number -
        In BPM Status - The Id of the status.
        In BPM path - The Id of the Status in which the path ends.
*/
    return window['bpmMain']?.openRulesReport?.(fromId, toId);
}

type ToStatusesResponse = Array<{
    title: string;
    id: string;
    color: string;
}>;

export function getToStatuses(statusName: string) {
    const res = window['bpmMain']?.getToStatuses?.(statusName);
    return Object.values<ToStatusesResponse>(res)[0] || [];
}

export function setSelectedStatusByStatusName(statusName: string) {
    return window['bpmMain']?.setSelectedStatusByStatusName?.(statusName);
}

export function getIsBPMChanged() {
    return window['bpmMain']?.getIsBPMChanged?.();
}

export function setIsBPMChanged(value: boolean) {
    return window['bpmMain']?.setIsBPMChanged?.(value);
}

export function handleClosePathRulesDialog(
    fromStatus: string,
    toStatus: string,
    hasAllowStatusChangeRule: boolean
) {
    return window['bpmMain']?.handleClosePathRulesDialog?.(
        getStatusID(fromStatus),
        getStatusID(toStatus),
        hasAllowStatusChangeRule
    );
}

export function getBpmBaseFormName(): string {
    return window['bpmMain']?.getBpmBaseFormName?.() || '';
}
